import { setToken, setPlatform, getToken, getPlatform } from '../helpers/apiConf'
import get from 'lodash/get'

const accessTokenMiddleware = (store: any) => (next: any) => (action: any) => {
  const state = store.getState()
  const token = get(state, 'oidc.user.access_token')
  const actualToken = getToken()
  const platform = get(state, 'oidc.user.profile.pla')
  const actualPlatform = getPlatform()

  if (platform && platform !== actualPlatform) {
    setPlatform(platform)
  }

  if (token && token !== actualToken) {
    setToken(token)
  }

  return next(action)
}

export default accessTokenMiddleware
